export default __webpack_public_path__ + "static/media/Roboto-Italic.beb7fe13.ttf";